let viewgird = [
  {
    path: '/Dev_RoleDeviceAuth',
    name: 'Dev_RoleDeviceAuth',
    component: () => import('@/views/device/Dev_RoleDeviceAuth.vue')
  },
  {
    path: '/Dev_RoleDeviceAuthTree',
    name: 'Dev_RoleDeviceAuthTree',
    component: () => import('@/views/device/Dev_RoleDeviceAuthTree.vue')
  },
  //
  // ----------
  // 备件管理
  {
    path: '/Dev_Materials',
    name: 'Dev_Materials',
    component: () => import('@/views/device/sparepartsmanagement/Dev_Materials.vue')
  },
  {
    path: '/Dev_MaterialApplicationApproval_Log',
    name: 'Dev_MaterialApplicationApproval_Log',
    component: () => import('@/views/device/sparepartsmanagement/Dev_MaterialApplicationApproval_Log.vue')
  },
  {
    path: '/Dev_MaterialApproval_Log',
    name: 'Dev_MaterialApproval_Log',
    component: () => import('@/views/device/sparepartsmanagement/Dev_MaterialApproval_Log.vue')
  },
  {
    path: '/Dev_MaterialInOut_Log',
    name: 'Dev_MaterialInOut_Log',
    component: () => import('@/views/device/sparepartsmanagement/Dev_MaterialInOut_Log.vue')
  },
  //
  // ----------
  // 维修管理
  {
    path: '/Dev_ConnectRepairDevice',
    name: 'Dev_ConnectRepairDevice',
    component: () => import('@/views/device/maintenancemanagement/Dev_ConnectRepairDevice.vue')
  },
  {
    path: '/Dev_DeviceRePairRequestForm',
    name: 'Dev_DeviceRePairRequestForm',
    component: () => import('@/views/device/maintenancemanagement/Dev_DeviceRePairRequestForm.vue')
  },
  {
    path: '/Dev_DeviceRePairApprove',
    name: 'Dev_DeviceRePairApprove',
    component: () => import('@/views/device/maintenancemanagement/Dev_DeviceRePairApprove.vue')
  },
  {
    path: '/Dev_DeviceRePairLog',
    name: 'Dev_DeviceRePairLog',
    component: () => import('@/views/device/maintenancemanagement/Dev_DeviceRePairLog.vue')
  },
  {
    path: '/Dev_PersonalCalendar',
    name: 'Dev_PersonalCalendar',
    component: () => import('@/views/device/maintenancemanagement/Dev_PersonalCalendar.vue')
  },
  //
  // ----------
  // 保养
  {
    path: '/Dev_MaintainDetailedList',
    name: 'Dev_MaintainDetailedList',
    component: () => import('@/views/device/maintainmanage/Dev_MaintainDetailedList.vue')
  },
  {
    path: '/Dev_MaintainPlan',
    name: 'Dev_MaintainPlan',
    component: () => import('@/views/device/maintainmanage/Dev_MaintainPlan.vue')
  },
  {
    path: '/Dev_MaintainTask',
    name: 'Dev_MaintainTask',
    component: () => import('@/views/device/maintainmanage/Dev_MaintainTask.vue')
  },
  {
    path: '/Dev_MaintainTaskLog',
    name: 'Dev_MaintainTaskLog',
    component: () => import('@/views/device/maintainmanage/Dev_MaintainTaskLog.vue')
  },
  {
    path: '/Dev_MaintainTemplate',
    name: 'Dev_MaintainTemplate',
    component: () => import('@/views/device/maintainmanage/Dev_MaintainTemplate.vue')
  },
  {
    path: '/Dev_ProcessConfig',
    name: 'Dev_ProcessConfig',
    component: () => import('@/views/device/maintainmanage/Dev_ProcessConfig.vue')
  },
  //售后管理-设备监测
  {
    path: '/Ser_DeviceMan',
    name: 'Ser_DeviceMan',
    component: () => import('@/views/servicing/Ser_DeviceMan.vue')
  },
  //售后管理-设备监测点击【出厂编号】跳转设备详情
  {
    path: '/Ser_EquipmentDetail',
    name: 'Ser_EquipmentDetail',
    component: () => import('@/views/servicing/Ser_EquipmentDetail.vue')
  },
  //售后管理-设备监测点击【客商名称】跳转客商详情
  {
    path: '/Ser_CustomerDetail',
    name: 'Ser_CustomerDetail',
    component: () => import('@/views/servicing/Ser_CustomerDetail.vue')
  },
  {
    path: '/Air_CustomerMaster',
    name: 'Air_CustomerMaster',
    component: () => import('@/views/device/air/Air_CustomerMaster.vue')
  },
  {
    path: '/Air_SalesContract',
    name: 'Air_SalesContract',
    component: () => import('@/views/device/air/Air_SalesContract.vue')
  },
  {
    path: '/Air_SalesOrder',
    name: 'Air_SalesOrder',
    component: () => import('@/views/device/air/Air_SalesOrder.vue')
  },
  {
    path: '/Air_Shipment',
    name: 'Air_Shipment',
    component: () => import('@/views/device/air/Air_Shipment.vue')
  },
  {
    path: '/Air_ReturnOrder',
    name: 'Air_ReturnOrder',
    component: () => import('@/views/device/air/Air_ReturnOrder.vue')
  },
  {
    path: '/Air_Receipt',
    name: 'Air_Receipt',
    component: () => import('@/views/device/air/Air_Receipt.vue')
  },
  {
    path: '/Air_ReceiveRefund',
    name: 'Air_ReceiveRefund',
    component: () => import('@/views/device/air/Air_ReceiveRefund.vue')
  },
  {
    path: '/Air_Invoice',
    name: 'Air_Invoice',
    component: () => import('@/views/device/air/Air_Invoice.vue')
  },
  {
    path: '/Air_SignConfirm',
    name: 'Air_SignConfirm',
    component: () => import('@/views/device/air/Air_SignConfirm.vue')
  },
  {
    path: '/Air_SalesOut',
    name: 'Air_SalesOut',
    component: () => import('@/views/device/air/Air_SalesOut.vue')
  },
  {
    path: '/Air_StoreProRecord',
    name: 'Air_StoreProRecord',
    component: () => import('@/views/device/air/Air_StoreProRecord.vue')
  },
  {
    path: '/Air_ProductionOrder',
    name: 'Air_ProductionOrder',
    component: () => import('@/views/device/air/Air_ProductionOrder.vue')
  },
  {
    path: '/Air_Equipment',
    name: 'Air_Equipment',
    component: () => import('@/views/device/air/Air_Equipment.vue')
  },
  {
    path: '/Air_CustomerContact',
    name: 'Air_CustomerContact',
    component: () => import('@/views/device/air/Air_CustomerContact.vue')
  },
  {
    path: '/Air_CustomerDetail',
    name: 'Air_CustomerDetail',
    component: () => import('@/views/device/air/Air_CustomerDetail.vue')
  },
  {
    path: '/Air_CustomerEquipment',
    name: 'Air_CustomerEquipment',
    component: () => import('@/views/device/air/Air_CustomerEquipment.vue')
  },
  {
    path: '/Air_MaterialDetail',
    name: 'Air_MaterialDetail',
    component: () => import('@/views/device/air/Air_MaterialDetail.vue')
  },
  {
    path: '/Air_CustomerShippingAddress',
    name: 'Air_CustomerShippingAddress',
    component: () => import('@/views/device/air/Air_CustomerShippingAddress.vue')
  },
  {
    path: '/Air_MaterialCategory',
    name: 'Air_MaterialCategory',
    component: () => import('@/views/device/air/Air_MaterialCategory.vue')
  },
  {
    path: '/Air_PartPrice',
    name: 'Air_PartPrice',
    component: () => import('@/views/device/air/Air_PartPrice.vue')
  },
  {
    path: '/Air_DeviceBatch',
    name: 'Air_DeviceBatch',
    component: () => import('@/views/device/air/Air_DeviceBatch.vue')
  },
  {
    path: '/Air_DeviceInfo',
    name: 'Air_DeviceInfo',
    component: () => import('@/views/device/air/Air_DeviceInfo.vue')
  },
  {
    path: '/DevicePartListPage',
    name: 'DevicePartListPage',
    component: () => import('@/views/device/air/DevicePartListPage.vue')
  },
  {
    path: '/Air_EquipmentDetail',
    name: 'Air_EquipmentDetail',
    component: () => import('@/views/device/air/Air_EquipmentDetail.vue')
  },
  {
    path: '/Air_SalesArea',
    name: 'Air_SalesArea',
    component: () => import('@/views/device/air/Air_SalesArea.vue')
  },
  {
    path: '/Air_ServiceSheet',
    name: 'Air_ServiceSheet',
    component: () => import('@/views/device/air/Air_ServiceSheet.vue')
  },
  {
    path: '/Air_Employee',
    name: 'Air_Employee',
    component: () => import('@/views/device/air/Air_Employee.vue')
  },
  {
    path: '/Air_Department',
    name: 'Air_Department',
    component: () => import('@/views/device/air/Air_Department.vue')
  },
  {
    path: '/Sys_Ezviz_Device',
    name: 'Sys_Ezviz_Device',
    component: () => import('@/views/sys/ezvdevice/Sys_Ezviz_Device.vue')
  },
  {
    path: '/Air_CollectionAgreement',
    name: 'Air_CollectionAgreement',
    component: () => import('@/views/device/air/Air_CollectionAgreement.vue')
  },
  {
    path: '/Air_Currency',
    name: 'Air_Currency',
    component: () => import('@/views/device/air/Air_Currency.vue')
  },
  {
    path: '/Air_SettlementMethod',
    name: 'Air_SettlementMethod',
    component: () => import('@/views/device/air/Air_SettlementMethod.vue')
  },
  {
    path: '/Air_TransactionType',
    name: 'Air_TransactionType',
    component: () => import('@/views/device/air/Air_TransactionType.vue')
  },
  {
    path: '/Dev_DevicePointEnergyLog',
    name: 'Dev_DevicePointEnergyLog',
    component: () => import('@/views/device/energy/Dev_DevicePointEnergyLog.vue')
  },
  {
    path: '/Dev_DeviceEnergy',
    name: 'Dev_DeviceEnergy',
    component: () => import('@/views/device/energy/Dev_DeviceEnergy.vue')
  },
  {
    path: '/Sys_User',
    name: 'Sys_User',
    component: () => import('@/views/system/Sys_User.vue')
  },
  {
    path: '/Sys_UserMenu',
    name: 'Sys_UserMenu',
    component: () => import('@/views/sys/sys/Sys_UserMenu.vue')
  },
  {
    path: '/Zt_TemplateData',
    name: 'Zt_TemplateData',
    component: () => import('@/views/device/zt/Zt_TemplateData.vue')
  },
  {
    path: '/Zt_Template',
    name: 'Zt_Template',
    component: () => import('@/views/device/zt/Zt_Template.vue')
  },
  {
    path: '/Zt_Component',
    name: 'Zt_Component',
    component: () => import('@/views/device/zt/Zt_Component.vue')
  },
  {
    path: '/Zt_CompCategory',
    name: 'Zt_CompCategory',
    component: () => import('@/views/device/zt/Zt_CompCategory.vue')
  },
  {
    path: '/Air_RoutineConfig',
    name: 'Air_RoutineConfig',
    component: () => import('@/views/device/air/Air_RoutineConfig.vue')
  },
  {
    path: '/Air_RoutineView',
    name: 'Air_RoutineView',
    component: () => import('@/views/device/air/Air_RoutineView.vue')
  },
  {
    path: '/Air_RoutineViewAudit',
    name: 'Air_RoutineViewAudit',
    component: () => import('@/views/device/air/Air_RoutineViewAudit.vue')
  },
  {
    path: '/Dev_RoutineView',
    name: 'Dev_RoutineView',
    component: () => import('@/views/device/inspection/Dev_RoutineView.vue')
  },
  {
    path: '/Air_RoutineInspection',
    name: 'Air_RoutineInspection',
    component: () => import('@/views/device/air/Air_RoutineInspection.vue')
  },
  {
    path: '/Air_CustomerIndustry',
    name: 'Air_CustomerIndustry',
    component: () => import('@/views/device/air/Air_CustomerIndustry.vue')
  },
  {
    path: '/Air_CustomerCategory',
    name: 'Air_CustomerCategory',
    component: () => import('@/views/device/air/Air_CustomerCategory.vue')
  },
  {
    path: '/SellOrder',
    name: 'SellOrder',
    component: () => import('@/views/order/sell/SellOrder.vue')
  },
  {
    path: '/Air_PartStock',
    name: 'Air_PartStock',
    component: () => import('@/views/device/air/Air_PartStock.vue')
  },
  // {
  //   path: '/Ops_MaintainDetailedList',
  //   name: 'Ops_MaintainDetailedList',
  //   component: () => import('@/views/device/ops/Ops_MaintainDetailedList.vue')
  // },
  // {
  //   path: '/Ops_MaintainPlan',
  //   name: 'Ops_MaintainPlan',
  //   component: () => import('@/views/device/ops/Ops_MaintainPlan.vue')
  // },
  // {
  //   path: '/Ops_MaintainTask',
  //   name: 'Ops_MaintainTask',
  //   component: () => import('@/views/device/ops/Ops_MaintainTask.vue')
  // },
  // {
  //   path: '/Ops_Materials',
  //   name: 'Ops_Materials',
  //   component: () => import('@/views/device/ops/Ops_Materials.vue')
  // },
  // {
  //   path: '/Ops_MaterialApplicationApproval_Log',
  //   name: 'Ops_MaterialApplicationApproval_Log',
  //   component: () => import('@/views/device/ops/Ops_MaterialApplicationApproval_Log.vue')
  // },
  // {
  //   path: '/Ops_DeviceRePairRequestForm',
  //   name: 'Ops_DeviceRePairRequestForm',
  //   component: () => import('@/views/device/ops/Ops_DeviceRePairRequestForm.vue')
  // },
  // {
  //   path: '/Ops_ConnectRepairDevice',
  //   name: 'Ops_ConnectRepairDevice',
  //   component: () => import('@/views/device/ops/Ops_ConnectRepairDevice.vue')
  // },
    //RTO
  {
    path: '/c1rto',
    name: 'C1RTO',
    component: () => import('@/views/RTOViews/C1RTO.vue')
  },
  {
    path: '/c5rto',
    name: 'C5RTO',
    component: () => import('@/views/RTOViews/C5RTO.vue')
  },
  {
    path: '/shuipingheng',
    name: 'ShuiPingHeng',
    component: () => import('@/views/RTOViews/ShuiPingHeng.vue')
  },
  {
    path: '/yacha',
    name: 'YaCha',
    component: () => import('@/views/RTOViews/YaCha.vue')
  },
  // {
  //   path: '/Ops_MaintainTemplate',
  //   name: 'Ops_MaintainTemplate',
  //   component: () => import('@/views/device/ops/Ops_MaintainTemplate.vue')
  // },
  {
    path: '/Air_MaintenanceLog',
    name: 'Air_MaintenanceLog',
    component: () => import('@/views/device/air/Air_MaintenanceLog.vue')
  },
  {
    path: '/Air_ProductionOrder_Device',
    name: 'Air_ProductionOrder_Device',
    component: () => import('@/views/device/air/Air_ProductionOrder_Device.vue')
  },
  {
    path: '/Air_ProductionOrder_DeviceParts',
    name: 'Air_ProductionOrder_DeviceParts',
    component: () => import('@/views/device/air/Air_ProductionOrder_DeviceParts.vue')
  },
];

export default viewgird;
